import { Divider } from "@mui/material";
import JSZip from "jszip";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { Card, CardBody, Row } from "reactstrap";

import { H4 } from "../../AbstractElements";
import CommonModal from "../../CommonElements/Modal";
import { useAppDispatch } from "../../ReduxToolkit/Hooks";
import { getAssessmentByParticipantId } from "../../ReduxToolkit/Reducers/AssessmentSlice";
import {
  getScormData,
  setScormToInitialValues,
} from "../../ReduxToolkit/Reducers/LearnerSlice";
import {
  InstructionHeadingForLearnerTakingAssessment,
  Start,
  Back,
} from "../../utils/Constant";
import {
  assessmentStatus,
  InstructionDataForLearnerForTakingAssessment,
  sanitizedContent,
} from "../../utils/helper/helper";
import {
  ASSESSMENT_PARTICIPANT_ID,
  OPENED_SCORM_DETAILS,
  saveToLocalStorage,
} from "../../utils/helper/localStorageutils";

const WBTTestStartInstruction = ({
  isOpen,
  toggle,
  name,
  participantId,
  termsAndCondition,
  status,
}) => {
  const dispatch = useAppDispatch();
  const sections = InstructionDataForLearnerForTakingAssessment.sections;
  const clickInfo = InstructionDataForLearnerForTakingAssessment.clickInfo;

  useEffect(() => {
    if (
      status === assessmentStatus.inProgress ||
      status === assessmentStatus.retake
    ) {
      dispatch(getAssessmentByParticipantId({ id: participantId })).then(
        (response: any) => {
          onPlayFile(response?.payload?.file_url);
        }
      );
    }
  }, [status, participantId]);

  const onPlayFile = async fileUrl => {
    try {
      const scormResponse = await dispatch(
        getScormData({ participantId: participantId?.toString() })
      );

      saveToLocalStorage(OPENED_SCORM_DETAILS, {});
      saveToLocalStorage(ASSESSMENT_PARTICIPANT_ID, participantId);
      const scormPackagePath = fileUrl;
      if (scormPackagePath.includes(".zip")) {
        const response = await fetch(scormPackagePath);
        const blob = await response.blob();
        const zip = await JSZip.loadAsync(blob);
        const files = [];
        zip.forEach((relativePath, file) => {
          files.push({ path: relativePath, file });
        });

        const indexFile = files.find(
          f =>
            f.path.endsWith("index.html") || f.path.endsWith("launchpage.html")
        );
        if (indexFile) {
          const content = await indexFile.file.async("string");
          const blob = new Blob([content], { type: "text/html" });
          const url = URL.createObjectURL(blob);
          const width = 1400;
          const height = 700;
          const left = window.screen.width / 2 - width / 2;
          const top = window.screen.height / 2 - height / 2;
          if (scormResponse?.payload?.data?.scorm_data) {
            saveToLocalStorage(
              OPENED_SCORM_DETAILS,
              scormResponse.payload.data
            );
          } else {
            saveToLocalStorage(OPENED_SCORM_DETAILS, {
              assessment_name: name,
              participant_id: participantId?.toString(),
              scorm_data: {},
            });
          }
          window.open(
            url,
            "_blank",
            `width=${width},height=${height},top=${top},left=${left}`
          );
        }
      }
    } catch (e) {
      dispatch(setScormToInitialValues());
      saveToLocalStorage(OPENED_SCORM_DETAILS, {});
    }
  };

  const handleStart = () => {
    toggle();
    dispatch(getAssessmentByParticipantId({ id: participantId })).then(
      (response: any) => {
        onPlayFile(response?.payload?.file_url);
      }
    );
  };

  if (
    status === assessmentStatus.inProgress ||
    status === assessmentStatus.retake
  ) {
    return null;
  }

  return (
    <CommonModal
      sizeTitle={name}
      modalBodyClassName=""
      isOpen={isOpen}
      toggle={toggle}
      backdrop="static"
      size="xl"
      showFooter
      primaryBtnText={Start}
      secondaryBtnText={Back}
      onPrimaryBtnClick={handleStart}
      onSecondaryBtnClick={toggle}
    >
      <Row>
        <Card>
          <CardBody>
            <H4>{InstructionHeadingForLearnerTakingAssessment}</H4>
            <Divider />
            {sections.map(section => (
              <div key={section.id} className="mt-3 p-1">
                <h5 className="fw-bold">{section.heading}</h5>
                <div
                  className="sanitized-content"
                  dangerouslySetInnerHTML={{
                    __html: sanitizedContent(section.content),
                  }}
                />
              </div>
            ))}
            {termsAndCondition && termsAndCondition !== "" && (
              <>
                <H4 className="p-2">{"Terms and Conditions : "}</H4>
                <Divider />
                <div
                  className="p-2 sanitized-content"
                  dangerouslySetInnerHTML={{
                    __html: sanitizedContent(termsAndCondition),
                  }}
                />
              </>
            )}
            <div
              className="sanitized-content"
              dangerouslySetInnerHTML={{
                __html: sanitizedContent(clickInfo),
              }}
            />
          </CardBody>
        </Card>
      </Row>
    </CommonModal>
  );
};

WBTTestStartInstruction.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  name: PropTypes.string,
  participantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  termsAndCondition: PropTypes.string,
  status: PropTypes.any,
};

export default WBTTestStartInstruction;
